import { createSlice } from "@reduxjs/toolkit";

const uploadSlice = createSlice({
  name: "uploads",
  initialState: {
    uploads: {},
  },
  reducers: {
    addUpload: (state, action) => {
      const { uploadId, fileName, fileSize, loaded = 0} = action.payload;
      state.uploads[uploadId] = {
        uploadId,
        fileName,
        fileSize,
        progress: 0,
        status: "uploading", // uploading, completed, error, cancelled
        uploadSpeed: "0 MB/s",
        loaded,
        eta: 0,
        error: null,
        retryCount: 0,
        maxRetries: 3,
        startTime: Date.now(),
      };
    },
    updateProgress: (state, action) => {
      const { uploadId, progress, uploadSpeed, eta, loaded} = action.payload;
      if (state.uploads[uploadId]) {
        state.uploads[uploadId].progress = progress;
        state.uploads[uploadId].uploadSpeed = uploadSpeed;
        state.uploads[uploadId].eta = eta;
        state.uploads[uploadId].loaded = loaded;
      }
    },
    updateStatus: (state, action) => {
      const { uploadId, status, error } = action.payload;
      if (state.uploads[uploadId]) {
        state.uploads[uploadId].status = status;
        if (error) state.uploads[uploadId].error = error;
      }
    },
    incrementRetry: (state, action) => {
      const { uploadId } = action.payload;
      if (state.uploads[uploadId]) {
        state.uploads[uploadId].retryCount++;
      }
    },
    removeUpload: (state, action) => {
      delete state.uploads[action.payload.uploadId];
    },
  },
});

export const {
  addUpload,
  updateProgress,
  updateStatus,
  incrementRetry,
  removeUpload,
} = uploadSlice.actions;

export default uploadSlice.reducer;
